module.exports = __webpack_public_path__ + "static/media/icon-open-event.d8a6f615.png";